import React from "react";
import { useWorldContract } from "../../../mud/useWorldContract";
import { Severity } from "@eveworld/types";
import configureSmartTurret from "../../systemCalls/handleConfigureSmartTurret";
import { EveButton } from "@eveworld/ui-components";
import { useNotification } from "@eveworld/contexts";

interface ButtonProps {
  AssemblyId: string;
}

const ButtonSetContractTurret: React.FC<ButtonProps> = ({ AssemblyId }) => {
  const { worldContract } = useWorldContract();
  const { notify } = useNotification();

  const handleSetContractTurret = async (SmartObjectId: string) => {
    const txHash = await configureSmartTurret({
      worldContract,
      smartObjectId: SmartObjectId,
      systemId:
        "0x737973636574726f765f637178000000536d6172745475727265745379737465",
    });
    if (txHash) {
      notify({ type: Severity.Success, txHash });
    } else {
      notify({
        type: Severity.Error,
        message: "Transaction failed to execute",
      });
    }
  };

  return (
    <EveButton
      typeClass="primary"
      onClick={() => handleSetContractTurret(AssemblyId)}
    >
      Set Contract
    </EveButton>
  );
};

export default React.memo(ButtonSetContractTurret);
